import React from 'react';

interface Props {
  children: React.ReactNode;
}

export const Dialog = ({ children }: Props) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white dark:bg-darkgray rounded-lg shadow-xl w-full max-w-md mx-4 border-2">
      {children}
    </div>
  </div>
);
